export const TITLE = "Ingrese un nombre para la relación";
export const NAME_LABEL = "Nombre";
export const BUTTON_LABEL = "Relacionar";
